const riskAppealList = () => import('@/views/riskAppeal/list')
const riskAppealDetail = () => import('@/views/riskAppeal/detail')
const riskAppealSearch = () => import('@/views/riskAppeal/search')
const riskAppealWithdrawalExample = () => import('@/views/riskAppeal/withdrawalExample')

export const riskAppeal = [
  {
    path: '/riskAppeal',
    name: 'riskAppealIndex',
    component: riskAppealList,
    meta: {
      title: '风控申诉',
      navBar: true
    }
  },
  {
    path: '/riskAppeal/withdrawalExample',
    name: 'riskAppealWithdrawalExample',
    component: riskAppealWithdrawalExample,
    meta: {
      title: '撤诉示例',
      navBar: true
    }
  },
  {
    path: '/riskAppeal/detail',
    name: 'riskAppealDetail',
    component: riskAppealDetail,
    meta: {
      title: '申诉',
      navBar: true
    }
  },
  {
    path: '/riskAppeal/search',
    name: 'riskAppealSearch',
    component: riskAppealSearch,
    meta: {
      title: '搜索',
      navBar: false
    }
  }
]
